import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAlgoListDataCachedSelectedDay,
  getIsMultiSelectSelected,
  getShiftPressed,
} from '../../../../stores/algos-list/getters';
import {
  selectAlgo,
  multiSelect,
  shiftSelectAlgo,
} from '../../../../stores/algos-list/actions';
import Checkbox from '../../../../components/light-weight/Checkbox';
import useAlgosData from '../../../../hooks/useAlgosData';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',

    '& .check-box': {
      '&:hover': {
        backgroundColor: 'var(--checkbox-bg)',
      },
    },
  },
}));

const CellCheckbox = ({ row = {} }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { original = {} } = row;
  const { _id = '' } = original;

  const shiftSelect = useSelector(getIsMultiSelectSelected);
  const isShiftPressed = useSelector(getShiftPressed);
  const algoData = useAlgosData();

  const selected = useSelector((state) => {
    const algos = getAlgoListDataCachedSelectedDay(state) || [];

    const { selected = false } = algos.find((d) => d._id === _id) || {};

    return selected;
  });

  const handleOnChange = () => {
    dispatch(selectAlgo(_id));

    if (isShiftPressed) {
      if (!shiftSelect) {
        dispatch(multiSelect(_id));
        return;
      }

      const indexStart = algoData.findIndex((d) => d._id === shiftSelect);
      const indexEnd = algoData.findIndex((d) => d._id === _id);

      const { selected: startSelected = false } =
        algoData.find((d) => d._id === shiftSelect) || {};

      let targets =
        indexStart >= indexEnd
          ? algoData.filter((_d, i) => i <= indexStart && i >= indexEnd)
          : algoData.filter((_d, i) => i >= indexStart && i <= indexEnd);

      targets = targets
        .map((item) => item._id)
        .filter((age, index, arr) => arr.indexOf(age) == index);

      dispatch(shiftSelectAlgo(targets, startSelected));
      dispatch(multiSelect(''));
    }
  };

  return (
    <div className={`${classes.root}`}>
      <Checkbox checked={selected} onChange={handleOnChange} />
    </div>
  );
};

export default CellCheckbox;
